import React from 'react';
import styles from "./ScoreExplainModal.module.css";
import { useIsShowScoreExplanation, useScoreExplanationposition } from '@/app/context/StateProvider';
export const ScoreExplainModal = () => {
  const [isShowScoreExplanation, setIsShowScoreExplanation] = useIsShowScoreExplanation();
  const [scoreExplanationPosition, setScoreExplanationPosition] = useScoreExplanationposition();
  return isShowScoreExplanation && <div className={styles.textModal} style={{
    top: scoreExplanationPosition.top,
    left: scoreExplanationPosition.left - 260
  }}>

            <div className={styles.container}>
                <div className={styles.header}>
                    <p>How Do We Calculate The Score?</p>
                </div>

                <div className={styles.textContent}>
                    <span>Our scoring system helps you make informed decisions by evaluating products based on user content, ensuring transparency and fairness:</span>
                    <ul>
                        <li><b>General Summary (weighted 60%): </b><span>Leverage the general quality and sentiment of user content.</span></li>
                        <li><b>Highlighted Topics (weighted 40%): </b><span>Focuses on detailed analyses and key insights from users, providing an in-depth understanding.</span></li>
                    </ul>
                </div>
            </div>

            <div className={styles.container}>
                <div className={styles.header}>
                    <p>Why Our Score Is Reliable?</p>
                </div>
                <div className={styles.textContent}>
                    <ul>
                        <li><b>Authenticity: </b><span>We only use verified user content, excluding any sponsored reviews.</span></li>
                        <li><b>Balanced Weighting: </b><span>Emphasis on detailed user feedback ensures a thorough evaluation.</span></li>
                        <li><b>Transparency: </b><span>Clear and consistent scoring criteria guarantee unbiased scores.</span></li>
                    </ul>
                </div>
            </div>

        </div>;
};